<app-profile-confirm-modal [toDo]="'confirm'" *ngIf="confirmModal"></app-profile-confirm-modal>
<div class="row margin-bottom mb8">
  <div class="col text-center sub_head">
    {{ 'YOUR_CURRENT_EMAIL_IS' | translate }} <br>
  </div>
</div>
<form 
  [formGroup]="editEmailForm" 
  name="editEmailForm"  
  (ngSubmit)="editEmailForm.valid && checkIfEmailExists()">
  <mapfre-alert></mapfre-alert>
  <div class="row">
    <div class="col">
      <div *ngFor="let input of inputs;index as i" class="inputs">
        <ng-container *ngIf="i!==1">
          <mapfre-validation [input]="input" [form]="editEmailForm"></mapfre-validation>    
        </ng-container>
        <ng-container *ngIf="i===1">
          <mapfre-validation [input]="input" [form]="editEmailForm"></mapfre-validation>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="row margin-top mt16">
    <div class="col">
      <mapfre-button
        [ngClass]="{'custom_loader':loader}"
        additionalClasses="basic primary large-btn h48 w-100 no-margin"
        [disabledValue]="editEmailForm.valid && !loader" 
        [inputType]="'submit'"
        [translateValue]="'CONTINUE' | translate"
      ></mapfre-button>
    </div>
  </div>
</form>

<div class="row margin-top mt24 text-center margin-bottom mb16">
  <div class="col">
    <mapfre-button
      (click)="onCheckDirty()"
      additionalClasses="link-button small-btn blue-link no-margin"
    >  {{ 'CANCEL' | translate }}
    </mapfre-button>
  </div>
</div>